import { Form } from "react-bootstrap";
import FormLabel from "./FormLabel";

const MAX_CHARACTERS = 5000;

interface Props {
  testId?: string;
  type?: string;
  className?: string;
  label?: string;
  field: string;
  value: any;
  placeholder?: string;
  required?: boolean;
  pattern?: string;
  invalidMessage?: string;
  onChange?: any;
  onBlur?: any;
  isValid?: boolean;
  disabled?: boolean;
  min?: string | number;
  max?: string | number;
  title?: string;
  feedbackLabel?: string;
  preventSubmitOnEnterKey?: boolean;
  id?: string;
  maxLength?: number;
}

function FormText({
  testId,
  type = "text",
  label = "",
  className = "",
  placeholder,
  field,
  required = false,
  pattern = ".*",
  invalidMessage = "",
  value = "",
  isValid = true,
  onChange,
  onBlur,
  disabled = false,
  min,
  max,
  feedbackLabel = label,
  preventSubmitOnEnterKey = true,
  id = field,
  maxLength = MAX_CHARACTERS,
}: Props) {
  return (
    <>
      {label && (
        <FormLabel
          testId={testId ? testId + "-label" : undefined}
          text={label}
          required={required}
          phoneNumber={field.toLowerCase().includes("phonenumber") ? value : ""}
        />
      )}
      <Form.Control
        data-testid={testId}
        type={type}
        className={className}
        name={field}
        id={id}
        value={value}
        pattern={pattern}
        onChange={onChange}
        onBlurCapture={onBlur}
        required={required}
        isInvalid={!isValid}
        disabled={disabled}
        max={max}
        min={min}
        onKeyDown={(e) => {
          preventSubmitOnEnterKey && e.key === "Enter" && e.preventDefault();
        }}
        maxLength={maxLength}
      />
      <Form.Control.Feedback
        type="invalid"
        data-testid={testId ? testId + "-error" : undefined}
      >
        {!disabled &&
          (feedbackLabel || invalidMessage) &&
          feedbackLabel +
            (value === "" && required ? " is required" : invalidMessage)}
      </Form.Control.Feedback>
    </>
  );
}

export default FormText;
